<template>
  <div class="header-nav-bar">
    <nav-bar
      class="header-nav-bar"
      left-arrow
      :border="false"
      fixed
      :z-index="999"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <icon name="arrow-left" size="1.5em" color="#000" />
      </template>
      <template #title>
        <nav-title :title="title"/>
      </template>
      <template #right>
        <slot name="right"/>
        <!-- <icon name="ellipsis" size="2em" color="#000" /> -->
      </template>
    </nav-bar>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant';
import NavTitle from './NavTitle.vue';
import { returnFromTask } from '@/utils/taskNavigation';

export default {
  components: {NavBar, Icon, NavTitle},
  props: {
    title: {
      type: String,
      default: '标题'
    },
    bgColor: {
      type: String,
      default: 'rgba(250, 251, 255, 1)'
    }
  },
  name: 'HeaderNavbar',
  methods:{
    onClickLeft() {
      returnFromTask(this.$router);
    },
    onClickRight() {
      this.$emit("clickRight")
    }
  }
};
</script>

<style scoped lang="scss">
.header-nav-bar {
  height: 46px;
  flex-shrink: 0;
  ::v-deep .van-nav-bar  {
    left: 50%;
    width: 100%;
    max-width: 480PX;
    transform: translateX(-50%);
    background-color: v-bind(bgColor);
  }
}
</style>
